// extracted by mini-css-extract-plugin
export default {"productsSelect":"_17GBUSmkmFSf2jKvwdnHwS"};